module.exports = __webpack_public_path__ + "static/images/general/subMenuIcon.png";